import React from 'react';
import { useCart } from '../../context/CartContext';
import ComboSuggestionModal from './ComboSuggestionModal';

/** Renders the combo upsell modal when triggered from add-to-cart. */
const ComboModalHost = () => {
  const { activeCombo, dismissComboModal } = useCart();
  return (
    <ComboSuggestionModal combo={activeCombo} onClose={dismissComboModal} />
  );
};

export default ComboModalHost;
